// Índice de documentos de la categoría: TikTok
import conectar_tiktok from './conectar-tiktok.js';

const tiktokDocs = [
  conectar_tiktok,
];

export default tiktokDocs;

